import React from 'react';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { ProAvatarProps } from './types';

export const ProAvatar = ({ user, avatarSize = 'xl' }: ProAvatarProps) => (
    <Avatar size={avatarSize} username={user.name} showRing={false}>
        <AvatarImage src={user.profileImageUrl} alt={user.name} />
    </Avatar>
);
